

























































































/* eslint-disable @typescript-eslint/no-var-requires */
import { Vue, Component, Watch } from "vue-property-decorator";
import FormattedAddress from "@/components/Address/FormattedAddress.vue";
import RequestStatusIcon from "@/components/Requests/RequestStatusIcon.vue";
import RequestTaskStatusIcon from "@/components/Requests/RequestTaskStatusIcon.vue";
import { Observer } from "mobx-vue";
import mapStore from "@/store/mapStore";
import { isTaskUnsuccessful } from "@/api/Requests";
import ButtonImageCarousel from "../ExpandableImage/ButtonImageCarousel.vue";
import { arePointsClose } from "@/helpers/LatituteLongitutehelper";
import { RequestModel } from "@/api/Requests";
import { datetimeLongExact, dateDayExact } from "@/filters/DateExact";

@Observer
@Component({ components: { FormattedAddress, RequestStatusIcon, RequestTaskStatusIcon, ButtonImageCarousel } })
class RequestPopup extends Vue {
  @Watch("mapStore.selectedRequest.requestId")
  async onSelectedRequestIdChanged() {
    if (this.mapStore.selectedRequest && this.mapStore.selectedRequest.requestId) {
      await this.mapStore.fetchRequestDetails(this.mapStore.selectedRequest);
    }
  }
  mapStore = mapStore;
  isTaskUnsuccessful = isTaskUnsuccessful;
  dispose?: () => void;

  get nearbyRequests() {
    if (!this.mapStore.selectedRequest || !this.mapStore.requests) {
      return [];
    }
    const lat = this.mapStore.selectedRequest.latitude;
    const lng = this.mapStore.selectedRequest.longitude;
    const filtered = this.mapStore.requests.filter((r: RequestModel) => {
      const close = arePointsClose(r.latitude, r.longitude, lat, lng);
      return close;
    });
    // Sort by requestId ascending
    const sorted = filtered.sort((a, b) => {
      if (a.requestId < b.requestId) return -1;
      if (a.requestId > b.requestId) return 1;
      return 0;
    });
    return sorted;
  }

  get thisIndex() {
    if (!this.mapStore.selectedRequest || !this.mapStore.selectedRequest.requestId) return null;
    const found = this.nearbyRequests.findIndex(r => r.requestId === this.mapStore.selectedRequest?.requestId);
    return found !== -1 ? found : null;
  }

  get next() {
    if (this.thisIndex === null) return null;
    if (this.thisIndex < this.nearbyRequests.length - 1) {
      return this.nearbyRequests[this.thisIndex + 1];
    }
    return null;
  }

  get previous() {
    if (this.thisIndex === null) return null;
    if (this.thisIndex > 0) {
      return this.nearbyRequests[this.thisIndex - 1];
    }
    return null;
  }

  destroyed() {
    if (this.dispose) {
      this.dispose();
    }
  }

  formatDatetimeLongExact(date: string | Date | null | undefined) {
    if (!date) return "";
    const iso = date instanceof Date ? date.toISOString() : date;
    return datetimeLongExact(iso);
  }

  formatDateDayExact(date: string | Date | null | undefined) {
    if (!date) return "";
    const iso = date instanceof Date ? date.toISOString() : date;
    return dateDayExact(iso);
  }
}

export default RequestPopup;
